import { IoIosClose } from 'react-icons/io';
export default IoIosClose;

//# sourceMappingURL=CloseBold.js.map